import { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import $ from "jquery";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../actions";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import update from "immutability-helper";
import api from "../../utils/axios";
import { showLoader, hideLoader, showAlert, isEmpty, isSingleSelect, showContaimerLoader, removeChar, hasPermission, showDBDate, validatedDate } from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import { statusOptions } from "./List";
const module = "crewplanner";
const modulePath = "/crewplanner";
const moduleName = "Crew Planner";
const moduleID = 47;

class Form extends Component {
  constructor(props) {
    super(props);
    const editID = this.props.location.state?.editID ?? "";
    this.state = {
      editID,
      postdata: {
        rank: "",
        client: "",
        vesselType: "",
        vesselName: "",
        cocAccepted: "",
        trading: "",
        wages: "",
        doj: "",
        immediate: false,
        otherInfo: "",
        status: "",
      },
      detaildata: [],
      rankList: [],
      clientList: [],
      vesselTypeList: [],
      vesselNameList: [],
      countryList: [],
      error_msg: "",
      pageloading: false,
    };
  }

  componentDidMount() {
    if (this.state.editID !== "") {
      if (!hasPermission(moduleID, "edit")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
        return;
      }
      const params = {
        params: "",
        url: `${module}/detail/${this.state.editID}`,
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    } else {
      if (!hasPermission(moduleID, "add")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
        return;
      }
    }
    this.loadDropdown();
  }

  loadDropdown() {
    api
      .get("rank/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ rankList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
    api
      .get("company/dropdownname")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ clientList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
    api
      .get("vesseltype/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ vesselTypeList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
    api
      .get("vessel/dropdownname")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ vesselNameList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
    api
      .get("others/countrylist")
      .then((res) => {
        if (res.data.status === "ok") {
          const countryList = (res.data.result || []).map((item) => ({ label: item.label, value: item.label }));
          this.setState({ countryList });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        const errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push(modulePath);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.detaildata !== nextProps.detaildata && nextProps.detaildata !== "" && this.state.editID !== "") {
      this.setState({ detaildata: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          const result = nextProps.detaildata[0].result;
          const isImmediate = result.immediate === "Yes" || result.immediate === true || result.doj === "immediate";
          const statusMatch = statusOptions.find((item) => item.value === result.status);
          const clientupdatedata = {
            rank: result.rank ? { label: result.rank, value: result.rank } : "",
            client: result.client ? { label: result.client, value: result.client } : "",
            vesselType: result.vesselType ? { label: result.vesselType, value: result.vesselType } : "",
            vesselName: result.vesselName ? { label: result.vesselName, value: result.vesselName } : "",
            cocAccepted: result.cocAccepted ? { label: result.cocAccepted, value: result.cocAccepted } : "",
            trading: result.trading || "",
            wages: result.wages || "",
            doj: !isImmediate ? validatedDate(result.doj) : "",
            immediate: isImmediate,
            otherInfo: result.otherInfo || "",
            status: result.status ? { label: statusMatch ? statusMatch.label : result.status, value: result.status } : "",
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.history.push(modulePath);
          showAlert("Error", "Invalid " + moduleName, "error");
        }
      });
    }
  }

  fieldChange = (field, value) => {
    this.setState((prevState) => update(prevState, { postdata: { [field]: { $set: removeChar(value) } } }));
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    const postData = this.state.postdata;
    const isImmediate = postData.immediate === true;

    const postObject = {
      rank: postData.rank?.value ?? "",
      client: postData.client?.value ?? "",
      vesselType: postData.vesselType?.value ?? "",
      vesselName: postData.vesselName?.value ?? "",
      cocAccepted: postData.cocAccepted?.value ?? "",
      trading: postData.trading,
      wages: postData.wages,
      doj: isImmediate ? "immediate" : showDBDate(postData.doj),
      immediate: isImmediate ? "Yes" : "",
      otherInfo: postData.otherInfo,
      status: postData.status?.value ?? "",
    };

    let post_url = `${module}`;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = "update";
    }
    this.props.getFormPost(postObject, post_url, method);
  };

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage={module} {...this.props} />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid  mx-3">
                  <div className="page-header">
                    <h1 className="page-title">
                      {this.state.editID !== "" ? "Update" : "Add New"} {moduleName}
                    </h1>
                    <div>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to={modulePath}>
                            <i className="fa fa-arrow-left me-1"></i>
                            GoBack
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="row" id="modulefrm">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        {this.state.pageloading ? (
                          showContaimerLoader()
                        ) : (
                          <PostForm
                            {...this.props}
                            fields={this.state.postdata}
                            rankList={this.state.rankList}
                            clientList={this.state.clientList}
                            vesselTypeList={this.state.vesselTypeList}
                            vesselNameList={this.state.vesselNameList}
                            countryList={this.state.countryList}
                            onChange={this.fieldChange}
                            onValid={this.handleSubmit}
                            editID={this.state.editID}
                            error_msg={this.state.error_msg}
                            onInvalid={() => {
                              setTimeout(function () {
                                if ($("#modulefrm .error").length > 0) {
                                  $("html, body").animate(
                                    {
                                      scrollTop: $(document).find("#modulefrm .error:first").offset().top - 100,
                                    },
                                    500,
                                  );
                                }
                              }, 500);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

export const isEmptyDoj = function (value, immediate) {
  if (immediate === true) {
    return null;
  }
  return value === "" ? "This field is required." : null;
};

function validationConfig(props) {
  const { rank, client, vesselType, vesselName, cocAccepted, trading, wages, doj, immediate, status } = props.fields;

  return {
    fields: ["rank", "client", "vesselType", "vesselName", "cocAccepted", "trading", "wages", "doj", "status"],
    validations: {
      rank: [[isSingleSelect, rank]],
      client: [[isSingleSelect, client]],
      vesselType: [[isSingleSelect, vesselType]],
      vesselName: [[isSingleSelect, vesselName]],
      cocAccepted: [[isSingleSelect, cocAccepted]],
      trading: [[isEmpty, trading]],
      wages: [[isEmpty, wages]],
      doj: [[isEmptyDoj, doj, immediate]],
      status: [[isSingleSelect, status]],
    },
  };
}

class PostForm extends Component {
  goBack() {
    this.props.history.push(modulePath);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  handleDojChange = (value) => {
    this.props.onChange("doj", value);
    if (value !== "" && value !== null) {
      this.props.onChange("immediate", false);
    }
  };
  handleImmediateChange = (e) => {
    const checked = e.target.checked;
    this.props.onChange("immediate", checked);
    if (checked) {
      this.props.onChange("doj", "");
    }
  };

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgrank,
      errMsgclient,
      errMsgvesselType,
      errMsgvesselName,
      errMsgcocAccepted,
      errMsgtrading,
      errMsgwages,
      errMsgdoj,
      errMsgstatus = "";
    if ($validation.rank.error.reason !== undefined) {
      errMsgrank = $validation.rank.show && <span className="error">{$validation.rank.error.reason}</span>;
    }
    if ($validation.client.error.reason !== undefined) {
      errMsgclient = $validation.client.show && <span className="error">{$validation.client.error.reason}</span>;
    }
    if ($validation.vesselType.error.reason !== undefined) {
      errMsgvesselType = $validation.vesselType.show && <span className="error">{$validation.vesselType.error.reason}</span>;
    }
    if ($validation.vesselName.error.reason !== undefined) {
      errMsgvesselName = $validation.vesselName.show && <span className="error">{$validation.vesselName.error.reason}</span>;
    }
    if ($validation.cocAccepted.error.reason !== undefined) {
      errMsgcocAccepted = $validation.cocAccepted.show && <span className="error">{$validation.cocAccepted.error.reason}</span>;
    }
    if ($validation.trading.error.reason !== undefined) {
      errMsgtrading = $validation.trading.show && <span className="error">{$validation.trading.error.reason}</span>;
    }
    if ($validation.wages.error.reason !== undefined) {
      errMsgwages = $validation.wages.show && <span className="error">{$validation.wages.error.reason}</span>;
    }
    if ($validation.doj.error.reason !== undefined) {
      errMsgdoj = $validation.doj.show && <span className="error">{$validation.doj.error.reason}</span>;
    }
    if ($validation.status.error.reason !== undefined) {
      errMsgstatus = $validation.status.show && <span className="error">{$validation.status.error.reason}</span>;
    }

    const selectPortalProps = {
      menuPortalTarget: document.body,
      menuPosition: "fixed",
      styles: { menuPortal: (base) => ({ ...base, zIndex: 9999 }) },
    };

    return (
      <div>
        <div className="card-body">
          <div className="form-row">
            <div className="form-group col-md-4">
              <label className="form-label">
                Rank<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.rank}
                onChange={this.handleSelectChange.bind(this, "rank")}
                placeholder="Select Rank"
                isClearable={true}
                options={this.props.rankList}
                {...selectPortalProps}
              />
              {errMsgrank}
            </div>
            <div className="form-group col-md-4">
              <label className="form-label">
                Client<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.client}
                onChange={this.handleSelectChange.bind(this, "client")}
                placeholder="Select Client"
                isClearable={true}
                options={this.props.clientList}
                {...selectPortalProps}
              />
              {errMsgclient}
            </div>
            <div className="form-group col-md-4">
              <label className="form-label">
                Vessel Type<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.vesselType}
                onChange={this.handleSelectChange.bind(this, "vesselType")}
                placeholder="Select Vessel Type"
                isClearable={true}
                options={this.props.vesselTypeList}
                {...selectPortalProps}
              />
              {errMsgvesselType}
            </div>
            <div className="form-group col-md-4">
              <label className="form-label">
                Vessel Name<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.vesselName}
                onChange={this.handleSelectChange.bind(this, "vesselName")}
                placeholder="Select Vessel Name"
                isClearable={true}
                options={this.props.vesselNameList}
                {...selectPortalProps}
              />
              {errMsgvesselName}
            </div>
            <div className="form-group col-md-4">
              <label className="form-label">
                COC Accepted<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.cocAccepted}
                onChange={this.handleSelectChange.bind(this, "cocAccepted")}
                placeholder="Select COC Accepted"
                isClearable={true}
                options={this.props.countryList}
                {...selectPortalProps}
              />
              {errMsgcocAccepted}
            </div>
            <div className="form-group col-md-4">
              <label className="form-label">
                Trading<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Trading"
                value={fields.trading}
                {...$field("trading", (e) => onChange("trading", e.target.value))}
              />
              {errMsgtrading}
            </div>
            <div className="form-group col-md-4">
              <label className="form-label">
                Wages<span className="lbl-error">*</span>
              </label>
              <input type="text" className="form-control" placeholder="Wages" value={fields.wages} {...$field("wages", (e) => onChange("wages", e.target.value))} />
              {errMsgwages}
            </div>
            <div className="form-group col-md-8">
              <label className="form-label">
                Date of Joining<span className="lbl-error">*</span>
              </label>
              <div className="d-flex align-items-start">
                <div style={{ minWidth: "200px" }}>
                  <DatePicker
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="Select Date of Joining"
                    className="form-control"
                    onKeyDown={(e) => e.preventDefault()}
                    selected={fields.doj}
                    dateFormat="dd-MM-yyyy"
                    isClearable={fields.doj !== ""}
                    onChange={this.handleDojChange}
                  />
                </div>
                <div className="mx-3 mt-2">OR</div>
                <div className="form-check mt-2">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="immediate"
                    checked={fields.immediate === true}
                    onChange={this.handleImmediateChange}
                  />
                  <label className="form-check-label" htmlFor="immediate">
                    Immediate
                  </label>
                </div>
              </div>
              {errMsgdoj}
            </div>
            <div className="form-group col-md-4">
              <label className="form-label">
                Status<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.status}
                onChange={this.handleSelectChange.bind(this, "status")}
                placeholder="Select Status"
                isClearable={true}
                options={statusOptions}
                {...selectPortalProps}
              />
              {errMsgstatus}
            </div>
            <div className="form-group col-md-8">
              <label className="form-label">Other Information</label>
              <input
                type="text"
                className="form-control"
                placeholder="Other Information"
                value={fields.otherInfo}
                {...$field("otherInfo", (e) => onChange("otherInfo", e.target.value))}
              />
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
            <div className="btn-group me-2 sw-btn-group-extra submit_frm" role="group">
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.$submit(onValid, onInvalid);
                }}
              >
                {this.props.editID !== "" ? "Update" : "Add New"}
              </button>

              <button className="btn btn-secondary" onClick={this.goBack.bind(this)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
